module.exports = __webpack_public_path__ + "fonts/font.5592133.woff2";